// extracted by mini-css-extract-plugin
module.exports = {"root":"Confirm_root__eXh7c"};